import React, { FC } from 'react';

import { Wysiwyg } from 'components/shared/Wysiwyg';
import { OnChangeState } from 'components/shared/Wysiwyg/Wysiwyg.types';

import { IWYSIWYGInputProps } from './types';

const WYSIWYGInput: FC<IWYSIWYGInputProps> = ({
  onChange,
  value,
  placeholder,
  onFocus,
  disabled,
  isReadonly = false,
  wrapperClassName,
  onBlur,
}) => {
  const onEditorStateChange = (state: OnChangeState) => {
    return onChange && onChange(state);
  };

  const handleFocus = (...args: [React.FocusEvent<HTMLDivElement>]) => {
    onFocus && !disabled && onFocus(...args);
  };

  return (
    <div onFocus={handleFocus} className={wrapperClassName}>
      <Wysiwyg
        type="secondary"
        data={value?.data?.text ? value.data : ''}
        placeholder={placeholder}
        onChange={onEditorStateChange}
        isDisabled={disabled}
        isReadOnly={isReadonly}
        onBlur={onBlur}
      />
    </div>
  );
};

export default WYSIWYGInput;
